const WORK_DIR = "/home/project";

export interface WebContainerFS {
  writeFile(path: string, contents: string | Uint8Array, opts?: { encoding?: string | null } | null): Promise<void>;
  mkdir(path: string, opts?: { recursive?: boolean }): Promise<void>;
}

// Intentional asymmetry: relative paths are prefixed under WORK_DIR; absolute paths pass through unchanged (WebContainer contract).
function absolutize(path: string): string {
  if (path.startsWith("/")) return path;
  return `${WORK_DIR}/${path}`.replace(/\/+/g, "/");
}

interface NodepodLike {
  fs: {
    writeFile(path: string, data: string | Uint8Array): Promise<void>;
    mkdir(path: string, opts?: { recursive?: boolean }): Promise<void>;
  };
}

export function createFsAdapter(nodepod: NodepodLike): WebContainerFS {
  return {
    async writeFile(path, contents, opts) {
      let data: string | Uint8Array = contents;
      if (opts?.encoding === "base64" && typeof contents === "string") {
        const bin = atob(contents);
        const bytes = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
        data = bytes;
      }
      await nodepod.fs.writeFile(absolutize(path), data);
    },
    async mkdir(path, opts) {
      await nodepod.fs.mkdir(absolutize(path), opts ? { recursive: opts.recursive } : undefined);
    },
  };
}
